var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 54,
    height: 54,
    transform: "translate(526 529)",
    fill: "#eceff4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(-526 -529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_7_1",
    "data-name": "Component 7 \\u2013 1",
    transform: "translate(521 508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    fill: "none",
    stroke: "#b0bed0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H59a0,0,0,0,1,0,0V58A17,17,0,0,1,42,75H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1H57a1,1,0,0,1,1,1V58A16,16,0,0,1,42,74H2a1,1,0,0,1-1-1V2A1,1,0,0,1,2,1Z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    d: "M0,0H52a0,0,0,0,1,0,0V37A15,15,0,0,1,37,52H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(526 529)",
    fill: "#eceff4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    transform: "translate(526 529)",
    fill: "#fff",
    stroke: "#b0bed0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0H47a0,0,0,0,1,0,0V31A16,16,0,0,1,31,47H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1H45a1,1,0,0,1,1,1V31A15,15,0,0,1,31,46H2a1,1,0,0,1-1-1V16A15,15,0,0,1,16,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-13 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M4.5,0,9,8H0Z",
    transform: "translate(556 555) rotate(-90)",
    fill: "#5b6c97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M0,2.232,3,0V15L0,13.167Z",
    transform: "translate(566 543)",
    fill: "#5b6c97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.43bd24adc8269f17ab2d2c591cf3d2a2.svg";
export { ForwardRef as ReactComponent };